<template>
    <div class="News">
        <div class="News-wrap">
            <h3>专业游艇码头制造商<br>Professional Floating Dock Manufacturer</h3>
        </div>

        <div class="navigation-wrap">

            <div class="navigation-bar">
                <div class="navigation-left-bar">
                    <p>您的位置：</p>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item>新闻资讯</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </div>

        <div class="News_wrap">
            <!-- //移动端新闻列表：整块做成一张卡片，手机上一屏能看两条 -->
            <div class="News_box" v-for="item in pagedList" :key="'m' + item.id">
                <router-link :to="'/n1?id=' + item.id">
                    <div class="News_img">
                        <img :src="coverOf(item)" :alt="item.title">
                    </div>
                    <div class="News_text">
                        <div class="News_text_box">
                            <h2>{{ item.title }}</h2>
                            <p>{{ item.summary }}</p>
                            <h5>{{ item.date }}</h5>
                        </div>
                    </div>
                </router-link>
            </div>
            <p v-if="!loading && !pagedList.length" class="News_empty">暂无新闻资讯</p>


            <!-- //PC新闻列表 -->
            <router-link :to="'/n1?id=' + item.id" v-for="item in pagedList" :key="'p' + item.id">
                <div class="News_list">

                    <div class="News_date_box">
                        <h3>{{ yearOf(item.date) }}</h3>
                        <p>{{ mdOf(item.date) }}</p>
                    </div>
                    <div class="News_txt">
                        <h2>{{ item.title }}</h2>
                        <p>{{ item.summary }}</p>
                    </div>
                    <div class="News_img_box">
                        <img :src="coverOf(item)" :alt="item.title">
                    </div>
                </div>
            </router-link>


        </div>

        <el-pagination v-if="news.length > pageSize" background layout="prev, pager, next"
            :total="news.length" :page-size="pageSize" :current-page="page"
            @current-change="handlePage">
        </el-pagination>


        <div class="Case_wrap">
            <section class="destination" id="destination">

                <div class="heading">
                    <h1>精美案例</h1>
                    <span>为您带来更多的可能性</span>
                    
                </div>

                <div class="box-container">


                    <div class="box" data-aos="fade-up" data-aos-delay="450">
                        <router-link to="/Case">
                            <div class="image">
                                <img src="../assets/images/des-3.jpg" alt="">
                            </div>
                            <div class="content">
                                <h3>国外项目</h3>
                                <p>2020-06<br>卡塔尔铝合金码头<br>案例</p>
                                <a href="#">了解更多 <i class="fas fa-angle-right"></i></a>
                            </div>
                        </router-link>
                    </div>

                    <div class="box" data-aos="fade-up" data-aos-delay="600">
                        <router-link to="/Case">
                            <div class="image">
                                <img src="../assets/images/des-4.jpg" alt="">
                            </div>
                            <div class="content">
                                <h3>国外项目</h3>
                                <p>2018-10 <br>迪拜码头<br>案例</p>
                                <a href="#">了解更多<i class="fas fa-angle-right"></i></a>
                            </div>
                        </router-link>
                    </div>

                    <div class="box" data-aos="fade-up" data-aos-delay="750">
                        <router-link to="/Case">
                            <div class="image">
                                <img src="../assets/images/des-5.jpg" alt="">
                            </div>
                            <div class="content">
                                <h3>国内案例</h3>
                                <p>2021-05<br>福建漳州沙滩网红冲浪浮桥<br>案例</p>
                                <a href="#">了解更多 <i class="fas fa-angle-right"></i></a>
                            </div>
                        </router-link>
                    </div>



                </div>

            </section>
        </div>

        <!-- banner section star-ts  -->
<!-- 
        <div class="banner">

            <div class="content" data-aos="zoom-in-up" data-aos-delay="300">
                <span>开平经祥港口设施工程有限公司</span>
                <h3>专业浮动码头制造商</h3>
                <p>开平经祥港口设施工程有限公司是一家专业从事于游艇码头，浮动码头，浮桥，浮动防波提，光伏浮筒及配套设施的企业，也是一家集研发、设计、销售、生产、施工、维护为一体化的专业公司。本公司拥有一支从业经验超过10年的专业团队，积累了丰富的水上工程经验和技术。
                </p>
               <router-link to="/Contact"> <a href="#book-form" class="btn">联系我们</a> </router-link>
            </div>

        </div> -->

        <!-- banner section ends -->

    </div>
</template>

<script>
import { getNewsList, assetUrl } from "../api/index"

export default {
    data() {
        return {
            news: [],
            loading: true,
            page: 1,
            pageSize: 5,
            defaultCover: require("../assets/images/blog-1.jpg")
        }
    },
    computed: {
        pagedList() {
            const start = (this.page - 1) * this.pageSize
            return this.news.slice(start, start + this.pageSize)
        }
    },
    methods: {
        coverOf(item) {
            if (item && item.cover) return assetUrl(item.cover)
            return this.defaultCover
        },
        yearOf(date) {
            return String(date || "").slice(0, 4) || "----"
        },
        mdOf(date) {
            return String(date || "").slice(5, 10) || "--"
        },
        handlePage(p) {
            this.page = p
        },
        load() {
            this.loading = true
            getNewsList().then(res => {
                const payload = (res.data && res.data.data) || {}
                this.news = payload.list || []
            }).catch(() => {
                this.news = []
            }).then(() => {
                this.loading = false
            })
        }
    },
    mounted() {
        this.load()
    }
}
</script>


<style>
    .News a {
        color: white;
    }

    .News-wrap {
        background: url('../assets/images/home-bg2.jpg');
        height: 350px;
        width: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: top;
        position: relative;
    }

    .News-wrap h3 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-size: 38px;
    }

    .News_wrap {
        max-width: 1500px;
        margin: 0 auto;
        position: relative;
    }

    .News_list {
        width: 90%;
        margin: 30px auto;
        height: 220px;
        border: 1px solid rgb(214, 214, 214);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        transition: all .2s linear;
        cursor: pointer;
        background: #fff;
    }

    .News_list:hover {
        width: 89%;
        box-shadow: 5px 5px 5px 5px #868686;
    }

    .News_date_box {
        width: 30%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    .News_date_box h3 {
        font-size: 36px;
        color: #000;
    }

    .News_date_box p {
        font-size: 20px;
        font-weight: bold;
        color: #000;
    }

    .News_txt {
        display: flex;
        /* align-items: center; */
        justify-content: center;
        flex-direction: column;
        text-align: left;
    }

    .News_txt h2 {
        padding-bottom: 15px;
        color: #000;
        font-size: 16px;
    }

    .News_txt p {
        color: #000;
        font-size: 12px;
    }

    .News_img_box {
        width: 30%;
        height: 100%;
        padding: 10px;
    }

    .News_img_box img {
        width: 100%;
        height: 100%;

    }

    .News_box {
        width: 90%;
        margin: 22px auto;
        background: #fff;
        border: 1px solid #e6e6e6;
        border-radius: 6px;
        overflow: hidden;
        position: relative;
        /* 桌面端隐藏，只在小屏显示 */
        display: none;
        transition: box-shadow .2s linear;
    }

    .News_box:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, .12);
    }

    .News_box:hover .News_text_box h2 {
        color: rgb(180, 63, 17);
    }

    .News_box a {
        color: inherit;
    }

    .News_box:hover .News_text_box p {
        color: rgb(255, 209, 83);
    }

    .News_text {
        padding: 14px 16px 16px;
    }

    .News_text2 {
        width: 500px;
        /* height: 330px; */
        background: rgb(253, 253, 253);
        position: absolute;
        top: 50%;
        right: -20px;
        transform: translateY(-50%);
    }

    .News_text_box {
        text-align: left;
    }

    .News_text_box h2 {
        font-size: 16px;
        line-height: 1.45;
        color: #000;
    }

    .News_text_box p {
        padding-top: 10px;
        font-size: 13px;
        line-height: 1.6;
        color: #666;
    }

    .News_text_box h5 {
        margin-top: 10px;
        text-align: right;
        font-size: 13px;
        color: #999;
    }

    .News_img {
        width: 100%;
        height: 190px;
        overflow: hidden;
    }

    .News_img img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }

    .Case_wrap {
        max-width: 1500px;
        margin: auto;
    }

    .Case_wrap .text-title {
        margin: 35px 0;
        /* height: 30px; */
    }

    .Case_wrap .text-title h2 {
        position: relative;
        font-size: 30px;
        padding-bottom: 5px;
        color: #000;
    }

    .Case_wrap .text-title h2::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 50px;
        height: 2px;
        background: rgb(180, 63, 17);
    }

    .Case_item {
        display: inline-block;
        width: 32%;
        height: 450px;
        border: 1px solid #e0e0e0;
        /* box-shadow: 5px 5px 10px 1px #e0e0e0; */

    }

    .Case_item2 {
        display: inline-block;
        width: 32%;
        margin: 20px 2%;
        height: 450px;
        border: 1px solid #e0e0e0;
        box-shadow: 5px 5px 10px 1px #e0e0e0;
    }

    .Case_item_img {
        width: 100%;
        height: 300px;
    }

    .Case_item_img img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .Case_item_text {
        width: 100%;
        height: 150px;
        line-height: 35px;
        background: #f5f5f552;
    }

    .Case_item_text h3 {
        font-size: 18px;
        padding: 20px 0 0 20px;
        text-align: left;
    }

    .Case_item_text h5 {
        font-size: 12px;
        text-align: left;
        padding-left: 65px;
        color: #ffffff;
    }

    .news_content_text{
        margin: 0 5%;
    }

    .Case_item_text p {
        font-size: 16px;
        text-align: right;
        padding-right: 20px;
        font-weight: bold;
        color: rgb(255, 255, 255);
    }

    .News section {
        padding: 3rem 9%;
    }

    @media screen and (max-width:768px) {
        .News-wrap h3 {
            width: 100%;
            font-size: 26px;
        }

        .News_list {
            display: none;
        }

        .News_box {
            width: 92%;
            display: block;
        }

        .News_text {
            padding: 12px 14px 14px;
        }

        .News_text2 {
            width: 100%;
            position: static;
            transform: none;
        }

        .News_img {
            height: 180px;
        }

        .Case_wrap {
            margin: 15px;
            border-top: 1px solid #eee;
            padding-top: 18px;
        }

        .Case_item {
            margin: 15px 0;
            width: 100%;
        }

        .Case_item2 {
            width: 100%;
            margin: 0;
        }
    }

    .News_empty {
        text-align: center;
        color: #999;
        font-size: 14px;
        padding: 40px 0;
    }
</style>